import {
  FundingSourceType,
  IPayrollSettings
} from "@wingspanhq/payments/dist/interfaces";
import { IClient } from "@wingspanhq/users/dist/lib/interfaces";
import {
  ExternalBankAccount,
  InternalAccount
} from "@wingspanhq/wingspan-api-sdk";
import { selectorExternalBankAccountFullName } from "@selectors/selectorExternalBankAccountFullName";
import { selectorCreditCardName } from "./selectorCreditCardName";
import { selectorFundingSource } from "./selectorFundingSource";

export const selectorFundingSourceName = (
  client: IClient,
  payrollSettings: IPayrollSettings,
  externalBankAccounts: ExternalBankAccount[],
  internalAccount?: InternalAccount
) => {
  const fundingSource = selectorFundingSource(payrollSettings, client);

  if (!fundingSource) {
    return;
  }

  switch (fundingSource.type) {
    case FundingSourceType.Account:
      const externalBankAccount = externalBankAccounts.find(
        externalBankAccount => externalBankAccount.id === fundingSource.id
      );

      if (externalBankAccount) {
        return selectorExternalBankAccountFullName(externalBankAccount);
      }
      break;

    case FundingSourceType.PaymentCard:
      const card = (client.profile.savedPaymentMethods || []).find(
        paymentMethod => paymentMethod.paymentMethodId === fundingSource.id
      );

      if (card) {
        return selectorCreditCardName(card);
      }
      break;

    case FundingSourceType.InternalAccount:
      if (
        payrollSettings.fundingSource?.fundingSourceType ===
        FundingSourceType.InternalAccount
      ) {
        return `Wingspan Wallet${
          internalAccount?.numbers?.account
            ? ` (${internalAccount.numbers.account.slice(-4)})`
            : ""
        }`;
      }
  }
};
